/**
 * helper to map rates to display string
 * @param rate
 * @returns
 */
export function mapOpportunityRateToString(rate) {
    if (!rate) {
        return '-';
    }
    if (rate === 'YEARLY') {
        return 'Anual';
    }
    // rate === 'MONTHLY'
    return 'Mensal';
}
